export default "__VITE_ASSET__DUhXgl7E__"